import { Get, Post, Put, Delete } from "./http";
import cookie from "../common/cookie";
import moment from 'moment'

let api = {
    //获取配置
    getConfig(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/messageHallConfigFindConfig", p);
    },
    //获取留言类型
    getMsgType(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/findMessageTypeList", p);
    },
    //最新发帖|最热发帖
    /**
     * 
     * 1, 最新发帖列表 排序字段： add_time desc

        2, 最热发帖列表 排序字段： thumbs_number desc
     */
    getMsgList(p = {}) {
        setSchoolCode(p)
        
        return Post("/messageHallHome/findPage", p);
    },
    getDepList(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/messageReplyDepartmentStatistic", p);
    },
    getSerList(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/serviceCentreThumsNumberStatistic", p);
    },
    getMsgTypeList(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/messageTypeStatistic", p);
    },
    //留言大厅-数据查询
    getSearchList(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/findPage", p);
    },
    //获取校区列表
    getAllCam(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/findCampusList", p);
    },
    //获取服务中心
    getAllSer(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/findServiceCentreList", p);
    },
    //获取部门
    getAllDep(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/findDepartmentList", p);
    },
    //获取部门
    getAllRep(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/findReplyPersonList", p);
    },

    //留言大厅-分类统计-留言类型统计
    getMsgTypeStatistic(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/statistic/messageTypeStatistic", p);
    },
    //留言大厅-分类统计-服务中心统计
    getSerStatistic(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/statistic/serviceCentreStatistic", p);
    },
    //留言大厅-分类统计-留言来源统计
    getSourceStatistic(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/statistic/messageSourceStatistic", p);
    },
    //留言大厅-统计排行-部门回复率排名
    getMsgDepStatistic(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/messageReplyDepartmentStatistic", p);
    },
    //留言大厅-统计排行-部门回复率排名
    getMsgPerStatistic(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/messageReplyStatistic", p);
    },
    //留言大厅-统计排行-部门回复率排名
    getSerThumsStatistic(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/serviceCentreThumsNumberStatistic", p);
    },
    //留言
    insertMessage(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/insertMessage", p);
    },
    //获取留言基础配置-游客是否可以留言
    getAllowVisistorMessage(p = {}) {
        setSchoolCode(p)
        return Post("/messageHallHome/findBasisConfigList", p);
    },


};
function setSchoolCode(obj) {
    obj.schoolCode = cookie.getCookie("SCHOOLCODE") || 10003;
}




// this.$api.getPlanList({
//     apiUrl: 1,
//     data: {
//
//     }
// }).then(res => {
//
// })
export default api;
